import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { ApiHttpClient } from 'app/http/clients/api';
import { TagLists } from 'app/models/cx-interaction/cx-interaction-tag-list.interface';
import { CxInteraction } from 'app/models/cx-interaction/cx-interaction.model';

@Injectable({
  providedIn: 'root'
})
export class CxInteractionService {

  constructor(private api: ApiHttpClient) { }

  getInteractionTagLists(): Observable<any> {
    const url = `${environment.API_URL}/cx-interaction/tag-lists`;

    return this.api.get<TagLists[]>(url);
  }

  saveCxInteraction(CxInteractionInfo): Observable<any> {
    const url = `${environment.API_URL}/cx-interaction`;
  
    return this.api.post<CxInteraction>(url, CxInteractionInfo);
  }
}
  
